<template>
  <div class="h-100vh">
    <div class="relative lg:py-32 md:py-32 py-20 bg-white h-100vh">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute top-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bg-designreg2 left-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/career-dots.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute bottom-32 right-0 md:block lg:block hidden">
        <img
          src="./../../assets/images/bg-des/CD-dots2.svg"
          alt="Dots"
          class=""
        />
      </div>
      <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div>
      <div class="absolute top-1/2 left-20 md:block lg:block hidden">
        <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
      </div>
      <div class="lg:flex md:flex gap-16 lg:px-10 md:px-10 px-3">
        <div class="lg:w-4/6 md:w-4/6 justify-center items-center mob-hidden">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/banner-latino-indian-man-woman-couple-use-their-laptop-living-room-make-video-calls-copy-space-video.jpg"
            alt=""
            class="object-contain w-full h-360px"
          />
        </div>
        <card class="shadow-lg lg:w-1/2 md:w-1/2 w-full h-auto">
          <div class="w-full bg-white">
            <div class="lg:px-4 md:px-3 px-0 lg:py-4 md:py-3 py-3 bg-eff2f7">
              <div class="flex items-center mb-6">
                <feather-icon
                  icon="ArrowLeftIcon"
                  svgClasses="w-5 h-5 mr-2"
                  class="cursor-pointer"
                  @click="backtologin"
                />
                <h4 class="text-xl font-medium">Change Password</h4>
              </div>
              <validation-observer ref="formValidator">
                <div v-show="!newpasswordpage">
                  <div class="mb-4">
                    <p class="lg:text-lg md:text-md text-sm text-center">
                      Please enter your email / mobile number.
                    </p>
                  </div>
                  <div
                    class="pb-4 flex justify-center"
                    v-show="!hideRoleSelect"
                  >
                    <el-select
                      v-model="selectedRole"
                      placeholder="role as a"
                      class="auto-width-select"
                      filterable
                      clearable
                      size="medium"
                      v-if="userCred && roles.length > 0"
                    >
                      <!-- :disabled="isRoleSelectDisabled" -->
                      <!-- popper-class="role-select-dropdown" -->
                      <el-option
                        v-for="role in roles"
                        :key="role"
                        :label="role"
                        :value="role"
                      />
                    </el-select>
                  </div>
                  <b-form
                    class="cust-bform lg:w-2/3 md:w-2/3 w-full mx-auto lg:px-0 md:px-0 px-2"
                    role="form"
                  >
                    <base-input
                      alternative
                      class="mb-3"
                      name="Email / Mobile "
                      :rules="{ required: true }"
                      prepend-icon="ni ni-email-83"
                      placeholder="Email / Mobile "
                      v-model="userCred"
                      @input="verifyUser(userCred)"
                      @keyup="handleUsername(userCred)"
                    >
                    </base-input>

                    <!-- <OTP
                      @set-otp="setOTP"
                      :userCred="userCred"
                      type="ForgotPassword"
                    /> -->
                    <OTP
                      :userCred="userCred"
                      @set-otp="otp = $event"
                      type="ForgotPassword"
                      ref="otpRef"
                      @countdown-started="handlecountdownStarted = $event"
                    />

                    <div class="flex justify-between mt-4 gap-4">
                      <base-button
                        type="primary"
                        outline
                        class="lg:px-6 md:px-4 px-2 lg:py-2 md:py-2 py-1 fsize16 sm-fsize12"
                        :disabled="
                          !isValidUserCred ||
                          selectedRole === '' ||
                          handlecountdownStarted
                        "
                        :class="{
                          'cursor-not-allowed opacity-50':
                            !isValidUserCred ||
                            selectedRole === '' ||
                            handlecountdownStarted,
                        }"
                        @click="$refs.otpRef.handleClick()"
                      >
                        Generate OTP
                      </base-button>

                      <base-button
                        type="primary"
                        class="lg:px-6 md:px-4 px-2 lg:py-2 md:py-2 py-1 fsize16 sm-fsize12"
                        :disabled="otp.length !== 4"
                        :class="{
                          'cursor-not-allowed opacity-50': otp.length !== 4,
                        }"
                        @click="verifyMobileNo()"
                      >
                        Verify OTP
                      </base-button>
                    </div>
                  </b-form>
                </div>
                <div v-show="newpasswordpage">
                  <div class="mb-3">
                    <h4 class="mb-2 text-xl font-medium">Enter New Password</h4>
                    <p class="text-lg">Please enter your new password</p>
                  </div>

                  <el-form ref="ruleForms" :model="ruleForm" :rules="rules">
                    <div class="relative">
                      <div class="mb-10">
                        <el-form-item prop="password">
                          <el-input
                            alternative
                            class="mb-3"
                            name="Password"
                            placeholder="New Password"
                            v-model="ruleForm.password"
                            :type="passwordFieldType1"
                          >
                          </el-input>
                        </el-form-item>
                        <div
                          class="absolute flex top-3 right-0"
                          @click="switchVisibility(1)"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2"
                            v-if="passwordFieldType1 === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                      <div class="relative">
                        <el-form-item prop="Passwordconfirm">
                          <el-input
                            alternative
                            class="mb-3"
                            name="Confirm Password"
                            placeholder="Confirm Password"
                            v-model="ruleForm.Passwordconfirm"
                            :type="passwordFieldType2"
                          >
                          </el-input>
                        </el-form-item>
                        <div
                          class="absolute flex top-3 right-0"
                          @click="switchVisibility(2)"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2 "
                            v-if="passwordFieldType2 === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                    </div>
                  </el-form>

                  <div class="flex justify-between mt-4">
                    <base-button
                      type="primary"
                      outline
                      class="w-2/5 mb-2"
                      @click="newpasswordpage = false"
                      >Back</base-button
                    >
                    <base-button
                      type="primary"
                      :disabled="
                        !(ruleForm.password && ruleForm.Passwordconfirm)
                      "
                      class="w-2/5 mb-2"
                      @click="handleSubmit('ruleForms')"
                      >Submit</base-button
                    >
                  </div>
                </div>
              </validation-observer>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import OTP from "./components/OTP.vue";
export default {
  data() {
    return {
      userCred: "",
      otp: "",

      rememberMe: false,
      Passwordreset: "",
      roles: [],
      selectedRole: "",
      // isRoleSelectDisabled: true,
      hideRoleSelect: true,
      newpasswordpage: false,
      handlecountdownStarted: false,
      passwordFieldType1: "password",
      passwordFieldType2: "password",
      ruleForm: {
        password: "",
        Passwordconfirm: "",
      },
      rules: {
        password: [
          {
            required: true,
            message: "Please Enter Password",
            trigger: "change",
          },
          {
            trigger: "change",
            message:
              "Password must be at least 8 character long and include at least 1 digit,1 lowercase,1 uppercasse, 1 special character.",
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
          },
        ],
        Passwordconfirm: [
          {
            trigger: "change",
            validator: this.conPassValidator,
          },
        ],
      },
    };
  },
  metaInfo: {
    title: "Reset or change your password Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Forgot Password? Follow the quick steps to reset your password. Login to Caregiver Saathi.",
      },
    ],
  },
  computed: {
    isValidUserCred() {
      return (
        /^\d{10}$/.test(this.userCred) ||
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.userCred)
      );
    },
  },

  methods: {
    handleUsername(val) {
      if (this.userCred.includes("@" && "."))
        this.userCred = this.userCred.toLowerCase();
    },
    async handleClick() {
      this.OTPCountdown = true;

      const payload = {
        type: this.type,
      };

      if (/^\d{10}$/.test(this.userCred)) {
        payload.mobile = this.userCred;
      } else if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.userCred)) {
        payload.email = this.userCred;
      }

      if (this.toActive) {
        payload.toActive = true;
      }

      try {
        const data = await this.$store.dispatch("auth/generateOTP", payload);
        if (data.code === 200) {
          this.$swal.fire({
            text: "OTP has been sent to your Email or Mobile",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
          });
        }
      } catch (error) {
        this.$swal.fire({
          title: "Error",
          text: error?.response?.data?.message || "Failed to send OTP",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
        });
      }
    },
    async verifyUser(val) {
      let payload;
      if (this.userCred.includes("CGX" && "EMP")) {
        payload = {
          eid: this.userCred,
          selectedRole: this.selectedRole,
        };
      } else if (this.userCred.includes("@" && ".")) {
        payload = {
          email: this.userCred.toLowerCase().trim(),
          selectedRole: this.selectedRole,
        };
      } else {
        payload = {
          mobile: this.userCred,
          selectedRole: this.selectedRole,
        };
      }
      try {
        const getUser = await this.$store.dispatch("auth/getUser", payload);
        const userList = getUser.data.user;

        this.allUsers = userList;

        const roles = userList.map((user) => user.role);
        const uniqueRoles = [...new Set(roles)];

        this.roles = uniqueRoles;

        if (this.roles.length === 1) {
          this.selectedRole = this.roles[0];
          this.hideRoleSelect = false;
        } else if (this.roles.length > 1) {
          this.selectedRole = "";
          this.hideRoleSelect = false;
        } else {
          this.selectedRole = "";
          this.hideRoleSelect = true;
        }
        // if (this.roles.length === 1) {
        //   this.selectedRole = this.roles[0];
        //   this.hideRoleSelect = true;

        //   if (this.otp && this.userCred) {
        //     this.verifyMobileNo();
        //   }
        // } else if (this.roles.length > 1) {
        //   this.selectedRole = "";
        //   this.hideRoleSelect = false;
        // } else {
        //   this.selectedRole = "";
        //   this.hideRoleSelect = true;
        // }
      } catch (error) {
        this.roles = [];
        this.selectedRole = "";
        this.hideRoleSelect = true;
        console.log(error);
        if (error.response.status) {
          if (
            this.$route.query.setPassword &&
            error.response.data.message !== "Please set password!"
          ) {
            this.$swal
              .fire({
                title: "Error",
                text: error.response.data.message,
                icon: "warning",
                confirmButtonColor: "#830c81",
                showCancelButton: false,
              })
              .then((result) => {
                if (error.response.data.message == "Please set password!") {
                  this.$router.push({
                    name: "forgot-password",
                    query: { setPassword: true },
                  });
                }
                if (
                  error.response.data.message.includes(
                    "Your account is in-active"
                  )
                ) {
                  this.$router.push({ name: "account-active" });
                  console.log("Move to activate account page");
                }
              });
          }
        }
      }
    },
    switchVisibility(val) {
      if (val === 1) {
        this.passwordFieldType1 =
          this.passwordFieldType1 === "password" ? "text" : "password";
      } else {
        this.passwordFieldType2 =
          this.passwordFieldType2 === "password" ? "text" : "password";
      }
    },
    setOTP(otp) {
      this.otp = otp;
    },
    async verifyMobileNo() {
      const payload = {
        // mobile: this.mobile,
        otp: this.otp,
        selectedRole: this.selectedRole,
      };

      if (/^\d{10}$/g.test(this.userCred)) {
        Object.assign(payload, { mobile: this.userCred });
      }

      if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(this.userCred)) {
        Object.assign(payload, { email: this.userCred });
      }

      // let loader = this.$loading();
      try {
        await this.$store.dispatch("auth/VerifyOTP", payload);
        if (this.$route.query.change) {
          await this.$store.dispatch("auth/passwordChangeRequest", payload);
          this.$swal.fire({
            title: "Sent",
            text: "Reset password link has been sent to your registered email!",
            confirmButtonText: "Okay",
            icon: "info",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.backtologin();
        } else {
          this.newpasswordpage = true;
        }
        // loader.close();
      } catch (error) {
        // loader.close();
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    conPassValidator(rule, value, callback) {
      if (value == "") {
        callback(new Error("Please Enter Confirm Password"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("Password do not match"));
      } else {
        callback();
      }
    },
    async handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (valid) {
          this.forgotPassword();
        } else {
          return false;
        }
      });
    },
    async forgotPassword() {
      let passFormat =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&^])[A-Za-z\d@.#$!%*?&]{8,15}$/;
      if (!passFormat.test(this.ruleForm.password)) {
        this.$swal.fire({
          text: "Password must be Alpha-Numberic containing capital, small and special charaters",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      const payload = {
        // mobile: this.mobile,
        password: this.ruleForm.password,
        selectedRole: this.selectedRole,
      };

      if (/^\d{10}$/g.test(this.userCred)) {
        Object.assign(payload, { mobile: this.userCred });
      }

      if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(this.userCred)) {
        Object.assign(payload, { email: this.userCred });
      }

      try {
        if (this.ruleForm.password == this.ruleForm.Passwordconfirm) {
          const data = await this.$store.dispatch(
            "auth/forgotPassword",
            payload
          );
          if (data.code == 200) {
            this.$swal.fire({
              text: "Password changed Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }

          this.$router.push({ name: "signin" });
          window.localStorage.setItem("forgotPassword", true);
        } else {
          this.$swal.fire({
            text: "Password Does not Match",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          return;
        }
      } catch (error) {
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async backtologin() {
      this.$router.push({ name: "signin" });
    },
  },
  components: {
    OTP,
  },
};
</script>
<style lang="scss">
.h-100vh {
  height: 100vh;
}
.login-tabs-container {
  min-height: 505px;
}
.cust-divider3 {
  border-bottom: 3px solid #e9ecef;
}
.fullpage-bgcolor {
  background-color: #eff2f7;
}
.bor {
  border: 1px solid rgba(155, 154, 154, 0.623);
}
.p-4 {
  padding: 1rem;
}

.bg-eff2f7 {
  background-color: #eff2f7;
}

.p-0card > .card-body {
  padding: 0px !important;
}

.root > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.root > div > .nav-tabs .nav-link {
  width: 220px;
  display: flex;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
    height: 60px;
  }
}
.root-il > div > .nav-tabs .nav-link {
  width: 120px;
  justify-content: center;
  @media (max-width: 640px) {
    width: auto;
  }
}
/* Oveerflow */
.cust-of > div > .nav {
  overflow-x: auto !important;
}
.cust-of > div > .nav::-webkit-scrollbar {
  width: 8px !important;
  height: 12px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-thumb:hover {
  background: #d6d6d6 !important;
}

.cust-of > div > .nav::-webkit-scrollbar-thumb {
  background: #d6d6d6 !important;
  border-radius: 6px !important;
}
.cust-of > div > .nav::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px #80808026 !important;
  border-radius: 6px !important;
}
.scope-padding > .card-body {
  padding-left: 0%;
  padding-right: 0%;
  padding-top: 0%;
  padding-bottom: 0%;
}

.root-il > div > .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  /* background: red; */
  /* border-top-width: 10px; */
  border-bottom: 4px solid #830c81;
  background-color: rgb(255, 255, 255);
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: 700;
  color: #333;
  display: flex;
  justify-content: center;
  /* background-color: antiquewhite; */
}
.root-il > div > .nav-tabs .nav-link {
  /* border: none !important; */
  border-radius: 0% !important;
}
.root-il > div > .nav-tabs .nav-item {
  flex-grow: 0 !important;
}
.root-il > div > .nav-tabs .nav-link:hover {
  /* border: none !important; */
  border-top: none;
  border-left: none;
  border-right: none;
  /* border-bottom: 4px solid #830c81; */
}
.root-il > div > .nav {
  flex-wrap: nowrap !important;
  overflow-y: hidden;
}
.aligncheck .custom-control-label {
  padding-top: 4px;
}
.cust-form-border > fieldset > div > div > input {
  border: 2px solid #830c81;
}
.form-group {
  margin-bottom: 0px !important;
}
.ublue {
  color: rgb(86, 86, 248);
}
.bg-0060fe {
  background-color: #0060fe;
}
.border-4f0a4b {
  border: 0.5px solid gray;
}
.h-560px {
  height: 560px;
}
.cust-form-border > fieldset > div > div > input {
  border: 1px solid #830c81 !important;
}
.cust-border {
  border-radius: 6px !important;
  border: 1px solid #830c81 !important;
}
.vue-country-select {
  border-radius: 6px !important;
  border: 1px solid #830c81 !important;
  height: calc(1em + 1.35rem + 4px) !important;
}
.vue-country-select .dropdown {
  padding: 0.5em 12px !important;
}
.width15 {
  width: 15.5rem !important;
}
.btn-linkedin {
  background: #0a66c2;
  color: white;
}
.w-240px {
  width: 220px !important;
}

.h-360px {
  height: 360px;
}

@media screen and (max-width: 640px) {
  .card-body {
    padding: 6px 6px !important;
  }
}
</style>
